<template>
  <div class='row justify-center q-ma-lg'>
     <div class="login-form">
        <div class='q-display-1 q-mb-lg'>Вход в систему</div>
        <form action="#" @submit.prevent="login">

          <div class="q-mb-lg">
            <!-- <label for="email">Username|Email</label> -->
            <q-input 
                v-model="username" 
                float-label="Имя пользователя" 
                class='login-input' />
            <!-- <input type="email" name="username" id="username" class="login-input" v-model="username"> -->
          </div>

          <div class="form-control mb-more">
            <!-- <label for="password">Password</label> -->
            <!-- <input type="password" name="password" id="password" class="login-input" v-model="password"> -->
            <q-input v-model="password" type="password" float-label='Пароль доступа в систему'  class='login-input' />
          </div>

          <div class="row justify-end q-ma-lg">
            <q-btn type="submit" class="btn-submit" color='positive' size='md' :loading="loading" style='width:150px;'>Вход</q-btn>
          </div> 

        </form>
          
      </div>
    
  </div>
</template>

<script>


/* eslint-disable */

export default {
  name : 'login',

  

  data() {

    return {
      username: localStorage.getItem('loginUserName') || "",
      password:'',
      loading : false,
    }

  },
  methods: {

    login() {
       this.loading = true;
       this.$store.dispatch('retrieveToken',{
         username : this.username,
         password : this.password,
       })
       .then((response)=>{         
         this.loading = false;
         localStorage.setItem('loginUserName', this.username);
         this.$router.push({name:'orders'}) //это переход на эту страницу
         
       })
       .catch((error) => {
            this.loading = false; 
            const n = {};
            n.message = 'Ошибка авторизации'
            n.detail = 'Неверные имя пользователя или пароль';
            n.position = 'bottom-right';
            this.$q.notify(n);
            this.password = '';

       });
    },

  }

}
</script>

<style>
  .login-input {
    border : 0px;
  }
  .login-form {
    margin-top: 50px;
    width : 400px;
  }
</style>

